module.exports = Em.Handlebars.compile("{{br formattedAddress}}");